import { render, staticRenderFns } from "./BoundedRichText.vue?vue&type=template&id=45570d1f&scoped=true"
import script from "./BoundedRichText.vue?vue&type=script&lang=js"
export * from "./BoundedRichText.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=45570d1f&prod&scoped=true&lang=css&external"
import style1 from "./BoundedRichText.vue?vue&type=style&index=1&id=45570d1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45570d1f",
  null
  
)

export default component.exports